import { useContext, useEffect, useState } from "react";
import { AppDB } from "../../App";
import {
  APPLICATION_AWAITING_CORRECTION,
  APPLICATION_TYPE_AMENDMENT,
  APPLICATION_TYPE_CORRECTION,
  APPLICATION_TYPE_REGISTRATION,
  APPLICATION_TYPE_REINSTATEMENT,
  APPLICATION_TYPE_REMOVAL,
  APPLICATION_TYPE_SUSPENSION,
  APPLICATION_TYPE_TRANSFER,
} from "../../constants";
import Edit_Application_Registration from "./Edit_Application_Registration";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import Edit_Application_requirement from "./Edit_Application_requirement";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Edit_Application_Helper } from "./Edit_Application_Helper";
import ScreenLoader from "../../componets/ScreenLoader";
import { editApplicationService } from "../../services/EditApplicationService";
import GenericFileCapture from "../../componets/GenericFileCapture";
import GenericUploadFileTable from "../../componets/GenericUploadFileTable";
import { Edit_Application_Validator } from "./Edit_Application_Validator";

Date.prototype.toIsoString = function () {
  var tzo = -this.getTimezoneOffset(),
    dif = tzo >= 0 ? "+" : "-",
    pad = function (num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? "0" : "") + norm;
    };
  return (
    this.getFullYear() +
    "-" +
    pad(this.getMonth() + 1) +
    "-" +
    pad(this.getDate()) +
    "T" +
    pad(this.getHours()) +
    ":" +
    pad(this.getMinutes()) +
    ":" +
    pad(this.getSeconds()) +
    dif +
    pad(tzo / 60) +
    ":" +
    pad(tzo % 60)
  );
};

export default function ({ application, onHide, type }) {
  const {
    toast,
    lookUp,
    showEditRegistration,
    setShowEditRegistration,
    refreshingApplication,
    seRefreshingApplication,
  } = useContext(AppDB);

  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [showFileUploader, setShowFileUploader] = useState(false);
  const [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);
  const [applicationState, setApplicationState] = useState({});
  const [refresh, setRefresh] = useState(false);

  const targetParts = application?.referralReasons?.map(
    (e) => e.referralReasonID
  );
  const ignore_validation = true;

  // sync incoming application → local state
  useEffect(() => {
    if (application) {
      setApplicationState(JSON.parse(JSON.stringify(application)));
    }
  }, [application]);

  console.log(application)

  // auto store uploaded files into applicationState
  useEffect(() => {
    if (fileUploaderDocuments.length > 0) {
      const clone = fileUploaderDocuments.map((doc) => {
        const _do = doc.binaryData.split(",");
        if (_do.length >= 2) {
          doc.FileExt = doc.fileExtension;
          doc.binaryTypeID = doc.documentTypeID;
          doc.binaryData = _do[1];
        }
        return doc;
      });
      setApplicationState((prev) => ({
        ...prev,
        fileUploaderDocuments: clone,
      }));
    }
  }, [fileUploaderDocuments]);

  // filter doc types based on type
  const [docList, setDocList] = useState([{}]);
  useEffect(() => {
    if (lookUp?.binaryTypes?.length) {
      let form = null;
      if (application?.registration !== null) {
        form = lookUp.binaryTypes.find((b) => b.id === 5); // Registration
      } else {
        form = lookUp.binaryTypes.find((b) => b.id === 6); // Amendment
      }
      setDocList(form ? [form] : []);
    }
  }, [lookUp, application?.applicationTypeID]);

  function excuteRequest(formObject) {
    setLoading(true);

    let editPromise;

    if (parseInt(type) === APPLICATION_TYPE_CORRECTION) {
      const correction = applicationState?.correction || {};

      // Pick only the fields required for the correction payload
      const correctionPayload = {
        applicationID: application?.applicationID,
        correctionID: correction.correctionID,
        registrationNumber: correction.registrationNumber,
        idNumber: correction.idNumber,
        placeOfIssue: correction.placeOfIssue,
        dateOfIssue: correction.dateOfIssue,
        dateOfBirth: correction.dateOfBirth,
        dateOfExpiry: correction.dateOfExpiry,
        surname: correction.surname,
        firstname: correction.firstname,
        middlename: correction.middlename,
        dobEstimated: correction.dobEstimated,
        dobEstimateDescription: correction.dobEstimateDescription,
        villageID: correction.villageID,
        dateRegistered: correction.dateRegistered,
        deceased: correction.deceased,
        disabilityID: correction.disabilityID,
        eligibleStatus: correction.eligibleStatus,
        registrationGPSAddress: correction.registrationGPSAddress,
        recordOwner: correction.recordOwner,
        nationality: correction.nationality,
        genderID: correction.genderID,
        mohaCheckDate: correction.mohaCheckDate,
        mohaStatus: correction.mohaStatus,
        mohaBatchRecordID: correction.mohaBatchRecordID,
        configurationID: correction.configurationID,
        applicationStatusID: correction.applicationStatusID,
        correctionNotes: correction.correctionNotes,

      };
      editPromise = editApplicationService.editCorrection(correctionPayload);
    }
    else {
      // Registration, amendment, others
      const basePayload = {
        ...formObject,
        ...applicationState,
        fileUploaderDocuments: applicationState.fileUploaderDocuments || [],
      };
      console.log("Submitting base payload:", basePayload);
      editPromise = editApplicationService.editApplication(
        applicationState.applicationID,
        basePayload
      );
    }

    editPromise
      .then((res) => {
        console.log("editApplication response:", res);
        if (res.success) {
          seRefreshingApplication(!refreshingApplication);
          setShowEditRegistration(false);
          onHide();
          toast.show({
            severity: "success",
            detail: "Application updated successfully",
            life: 2500,
          });
        } else {
          toast.show({
            severity: "error",
            detail: res?.message || "Unable to update application",
            life: 2500,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("editApplication error:", err);
        toast.show({
          severity: "error",
          detail: "Unexpected error updating application",
          life: 2500,
        });
        setLoading(false);
      });
  }



  // main submit function
  function submitApplication(e) {
    e?.preventDefault();
    console.log("Submitting type:", type, "state:", applicationState);

    if (parseInt(type) === APPLICATION_TYPE_REGISTRATION) {
      const form = Edit_Application_Helper.makeRegistation(toast, applicationState);
      console.log("Registration form:", form);

      const valid = Edit_Application_Validator.registration_validation(
        "registration",
        applicationState,
        application,
        fileUploaderDocuments,
        toast,
        application?.referralReasons
      );
      if (!valid) return;


      if (form.success) {
        console.log("Executing request for registration...");
        excuteRequest(form.form); // this will now merge with applicationState + docs
      }
    }

    if (parseInt(type) === APPLICATION_TYPE_AMENDMENT) {

      const valid = Edit_Application_Validator.amendment_validation(
        "amendment",
        applicationState,
        application,
        fileUploaderDocuments,
        toast,
        application?.referralReasons
      );
      if (!valid) return;

      const form = Edit_Application_Helper.makeAmendment(applicationState);
      console.log("Amendment form:", form);
      if (form.success) {
        console.log("Executing request for amendment...");
        excuteRequest(form.form);
      }
    }

    if (parseInt(type) === APPLICATION_TYPE_CORRECTION) {
      const form = Edit_Application_Helper.makeCorrection(applicationState);
      console.log("Correction form:", form);
      if (form.success) {
        console.log("Executing request for correction...");
        excuteRequest(form.form);
      }
    }
  }

  console.log(application)
  // prevent disabled gray button
  const css = `.p-accordion-header .p-accordion-header-link *{
    color:black !important;
    opacity:1 !important;
  }`;

  return (<>
    <Dialog
      header={<p><b>Application - {application?.referenceNumber}</b></p>}
      style={{ width: "100%", maxWidth: "900px" }}
      footer={<>
        <Button
          loading={loading}
          className="p-button-primary"
          type="button"
          label="Submit"
          disabled={!checked}
          onClick={submitApplication}
        />
        <Button
          loading={loading}
          className="p-button-danger"
          type="button"
          label="Close"
          onClick={() => setShowEditRegistration(false)}
        />
      </>}
      visible={showEditRegistration} onHide={() => {
        if (!loading) {
          // setRefresh(!refresh)
          setShowEditRegistration(false)
        }


      }}>
      <style>
        {css}
      </style>
      <ScreenLoader visible={loading} />

      {/* Put Implementations for actioning Correction */}

      <Edit_Application_requirement
        application={application}


      />
      <Accordion activeIndex={0} className="mt-2">
        <AccordionTab disabled header="Form">
          <>
            {type == APPLICATION_TYPE_REGISTRATION && <>
              <Edit_Application_Registration
                application={applicationState}
                setApplication={setApplicationState}
                onHide={onHide}
                type="registration"
                ignore_validation={ignore_validation}
                targetParts={targetParts}
              />

            </>}
            {type == APPLICATION_TYPE_AMENDMENT && <>

              <Edit_Application_Registration
                application={applicationState}
                setApplication={setApplicationState}
                onHide={onHide}

                ignore_validation={ignore_validation}


                type={"amendment"}
                targetParts={targetParts}

              />
            </>}

            {type == APPLICATION_TYPE_CORRECTION && <>

              <Edit_Application_Registration
                application={applicationState}
                setApplication={setApplicationState}
                onHide={onHide}

                ignore_validation={ignore_validation}


                type={"correction"}
                targetParts={targetParts}

              />
            </>}
            {type == APPLICATION_TYPE_TRANSFER && <></>}

            {type == APPLICATION_TYPE_SUSPENSION && <></>}
            {type == APPLICATION_TYPE_REINSTATEMENT && <></>}
            {type == APPLICATION_TYPE_REMOVAL && <></>}

            {
              type != APPLICATION_TYPE_CORRECTION && (
                (targetParts?.includes(3) || ignore_validation) && (
                  <>
                    <div >
                      <GenericFileCapture
                        dontClearDocuments={true}
                        refresh={refresh} setRefresh={setRefresh}
                        extraAttributes={{
                          // "candidateID": selectedCanditate.candidateID,
                          // "eventID": showCandidateDialog?.event?.eventID
                        }}
                        documentTypesLookUp={docList} show={showFileUploader} setShow={setShowFileUploader}
                        setDocuments={setFileUploaderDocuments}
                        documents={fileUploaderDocuments}
                      />
                      <GenericUploadFileTable
                        header={<div className="col-12  lg:col-3 my-2">
                          <label htmlFor="description">
                            Upload Documents
                          </label>
                          <br />
                          <>
                            <Button
                              label={"Upload"}
                              onClick={() => setShowFileUploader(true)}
                              className="p-button-success"
                              icon={"pi pi-plus"}
                            />
                          </>
                        </div>}
                        setDocuments={setFileUploaderDocuments}
                        documents={fileUploaderDocuments}
                      />
                    </div>
                  </>)
              )
            }

          </>


        </AccordionTab>
      </Accordion>


      {/* <APPLICATION_TYPE_REGISTRATION/> */}
      <div className="col-12 md:col-12 lg:col-12">
        <Checkbox onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
        <span className="px-2">I confirm that the information captured is correct.</span>
      </div>
    </Dialog>
  </>)
}